import { render, staticRenderFns } from "./PartyRoleTypesView.vue?vue&type=template&id=49c7c342&scoped=true&"
import script from "./PartyRoleTypesView.vue?vue&type=script&lang=js&"
export * from "./PartyRoleTypesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7c342",
  null
  
)

export default component.exports